// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Ban: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M20.45,3.55c-2.26-2.26-5.26-3.5-8.45-3.5s-6.19,1.24-8.45,3.5S0.05,8.81,0.05,12c0,3.19,1.24,6.19,3.5,8.45
	s5.26,3.5,8.45,3.5s6.19-1.24,8.45-3.5c2.26-2.26,3.5-5.26,3.5-8.45C23.95,8.81,22.71,5.81,20.45,3.55z M19.46,4.54
	c1.99,1.99,3.09,4.64,3.09,7.46c0,2.58-0.93,5.02-2.62,6.94L5.06,4.07C6.98,2.38,9.42,1.45,12,1.45
	C14.82,1.45,17.47,2.55,19.46,4.54z M4.54,19.46C2.55,17.47,1.45,14.82,1.45,12c0-2.58,0.93-5.02,2.62-6.94l14.87,14.87
	c-1.92,1.69-4.36,2.62-6.94,2.62C9.18,22.55,6.53,21.45,4.54,19.46z"/>
</svg>;
};

export default React.memo(Ban);
